/* eslint-disable comma-dangle */
/* eslint-disable arrow-body-style */
import React from 'react';
import {
  Page, Text, View, Document, Image, StyleSheet,
} from '@react-pdf/renderer';
import PropTypes from 'prop-types';
import moment from 'moment';
import { getCategoryName, getLabelFromType, getLabelFromSubcategory } from '../../../utils/functions';

const idLocale = require('moment/locale/fr');

moment.locale('fr', idLocale);

// Create styles
const styles = StyleSheet.create({
  coverPage: {
    flexDirection: 'column',
    backgroundColor: '#fff',
    padding: 20,
  },
  page: {
    flexDirection: 'column',
    backgroundColor: '#fff',
    paddingTop: 80,
    paddingBottom: 30,
    paddingHorizontal: 30,
  },
  image: {
    width: '25%',
  },
  firstPage: {
    justifyContent: 'center',
    flexGrow: 1
  },
  fullPage: {
    flexGrow: 1,
  },
  borderBot: {
    margin: '20px auto',
    borderBottomColor: '#ccc',
    borderBottomWidth: 1,
    paddingBottom: 20,
  },
  flexed: {
    display: 'flex',
    flexDirection: 'column',
  },
  title: {
    fontSize: 20,
    textAlign: 'center'
  },
  subTitle: {
    fontSize: 16,
    marginBottom: 20,
    borderBottomWidth: 1,
    borderBottomColor: '#ccc',
  },
  bigTitle: {
    fontSize: 32,
    textAlign: 'center'
  },
  titleCat: {
    fontSize: 24,
    fontWeight: 'bold',
  },
  categoryWrapper: {
    marginBottom: 40,
  },
  subText: {
    fontSize: 12,
    textAlign: 'center',
    color: '#4A4A4A'
  },
  logo_wrapper: {
    alignItems: 'center'
  },
  pageNumbers: {
    position: 'absolute',
    bottom: 20,
    right: 20,
    fontSize: 12,
  },
  pageHeader: {
    position: 'absolute',
    top: 30,
    left: 30,
    fontWeight: 'bold',
    fontSize: 14,
    borderBottomWidth: 1,
    borderBottomColor: '#ccc',
    width: '100%',
    paddingBottom: 10,
    textTransform: 'uppercase'
  },
  mt20: {
    marginTop: 20,
  },
  infoRow: {
    borderTopColor: '#ccc',
    borderTopWidth: 1,
    paddingVertical: 6,
  },
  flexRow: {
    flexDirection: 'row',
  },
  padded: {
    marginTop: 20,
    padding: 20,
    borderColor: '#ccc',
    borderWidth: 1,
  },
  leftColumn: {
    flexDirection: 'column',
    flexGrow: 9,
  },
  rightColumn: {
    flexDirection: 'column',
    flexGrow: 1,
    alignItems: 'flex-end',
    justifySelf: 'flex-end',
  },
  assetTitle: {
    marginBottom: 10,
  },
  assetLastUpdated: {
    marginBottom: 10,
    color: '#999',
    fontSize: 10,
  },
  infoText: {
    fontSize: 12,
  },
  lighter: {
    color: '#999',
  },
});

const infoElement = (value = '', label, type) => (
  <View style={[styles.infoRow, type === 'notes' ? {} : styles.flexRow]} wrap={false}>
    <View style={styles.leftColumn} wrap={false}>
      <Text style={styles.infoText} wrap={false}>{label}</Text>
    </View>
    {
      type === 'notes' ? (
        <View wrap={false}>
          <Text style={styles.infoText} wrap={false}>"{value}"</Text>
        </View>
      ) : (
        <View style={styles.rightColumn} wrap={false}>
          <Text style={[styles.infoText, type === 'hidden' && styles.lighter]} wrap={false}>{value}</Text>
        </View>
      )
    }
  </View>
);

const getAnnexes = (e) => {
  const final = [];
  if (e.type !== undefined && e.type !== null && e.type.length > 0) final.push(infoElement(getLabelFromType(e.subcategory, e.type), 'Catégorie :'));
  if (e.login_email) final.push(infoElement(e.login_email, 'Identifiant de connexion :'));
  if (e.login_other) final.push(infoElement(e.login_other, 'Autre identifiant :'));
  if (e.url !== undefined && e.url !== null && e.url.length > 0) final.push(infoElement(e.url, 'Lien du compte :'));
  if (e.credential) final.push(infoElement(e.credential, 'Identifiant du compte :'));
  if (e.contract_name) final.push(infoElement(e.contract_name, 'Nom du contrat :'));
  if (e.contract) final.push(infoElement(e.contract, 'Numéro de contrat :'));
  if (e.address) final.push(infoElement(e.address, 'Adresse :'));
  if (e.public_key) final.push(infoElement(e.public_key, 'Clé publique :'));
  if (e.iban) final.push(infoElement(e.iban, 'IBAN :'));
  if (e.bic) final.push(infoElement(e.bic, 'Code BIC / SWIFT :'));
  if (e.cloud_choice !== undefined && e.cloud_choice !== null && e.cloud_choice === 'delete') final.push(infoElement('Suppression intégrale', 'Choix en cas de décès :'));
  if (e.cloud_choice !== undefined && e.cloud_choice !== null && ['transmit_part', 'transmit_full'].includes(e.cloud_choice)) final.push(infoElement('Transmission', 'Choix en cas de décès :'));
  if (e.permalinks !== undefined && e.permalinks !== null && e.permalinks.length > 0) final.push(infoElement('à retrouver dans Legitbee', `${e.permalinks.length} permalien${e.permalinks.length > 1 ? 's' : ''} :`, 'hidden'));
  if (e.contacts !== undefined && e.contacts !== null && e.contacts.length > 0) final.push(infoElement('à retrouver dans Legitbee', `${e.contacts.length} contact${e.contacts.length > 1 ? 's' : ''} :`, 'hidden'));
  if (e.documents && e.documents.length > 0) final.push(infoElement('à retrouver dans Legitbee', `${e.documents.length} document${e.documents.length > 1 ? 's' : ''} associé${e.documents.length > 1 ? 's' : ''} :`, 'hidden'));
  if (e.images && e.images.length > 0) final.push(infoElement('à retrouver dans Legitbee', `${e.images.length} photo${e.images.length > 1 ? 's' : ''} associée${e.images.length > 1 ? 's' : ''} :`, 'hidden'));
  return final;
};

const getContactInfo = (e) => {
  const final = [];
  if (e.role !== undefined && e.role !== null && e.role.label.length > 0) final.push(infoElement(e.role.label, 'Rôle :'));
  if (e.company !== undefined && e.company !== null && e.company.length > 0) final.push(infoElement(e.company, 'Cabinet / Entreprise :'));
  if (e.email !== undefined && e.email !== null && e.email.length > 0) final.push(infoElement(e.email, 'Email :'));
  if (e.phone !== undefined && e.phone !== null && e.phone.length > 0) final.push(infoElement(e.phone, 'Téléphone :'));
  if (e.notes !== undefined && e.notes !== null && e.notes.length > 0) final.push(infoElement(e.notes, 'Informations complémentaires :', 'notes'));
  return final;
};

const listElements = (data, list_assets, contacts_pro) => {
  // display all extra information for estate and company
  const {
    linked_info, instructions, category, _id,
  } = data;
  let assetsLinked = [];
  if (category === 'company') {
    assetsLinked = list_assets.filter(e => e.linked_company_id === _id);
    console.log('must list assets linked: ', assetsLinked);
  }
  const list_contacs_pro = contacts_pro.filter(e => e.linked_asset_id === _id);
  console.log(list_contacs_pro);
  const isNeedPadding = (linked_info && linked_info.length > 0) || assetsLinked.length > 0 || list_contacs_pro.length > 0 || instructions;
  return (
    <View style={isNeedPadding ? styles.padded : {}} wrap={false}>
      {/* Onglet "Administratif / annexes" */}
      {
        linked_info && linked_info.length > 0 && (
          <View style={styles.flexed} wrap={false}>
            <Text style={styles.subTitle} wrap={false}>Annexes</Text>
            {linked_info.map(e => (
              <View wrap={false}>
                <Text style={styles.mt20} wrap={false}>
                  {getLabelFromSubcategory(e.subcategory, e.category)}
                </Text>
                <Text style={styles.assetLastUpdated} wrap={false}>
                  Dernière mise à jour : {moment(e.updated_at).format('L')}
                </Text>
                <View wrap={false}>
                  {getAnnexes(e).map(item => item)}
                </View>
              </View>
            ))}
          </View>
        )
      }
      {/* Onglet "Patrimoine" pour une entreprise */}
      {
        assetsLinked.length > 0 && (
          <View style={[styles.flexed, styles.mt20]} wrap={false}>
            <Text style={styles.subTitle} wrap={false}>Patrimoine</Text>
            {assetsLinked.map(e => (
              <View wrap={false}>
                <Text style={styles.mt20} wrap={false}>
                  {e.title}
                </Text>
                <Text style={styles.assetLastUpdated} wrap={false}>
                  Dernière mise à jour : {moment(e.updated_at).format('L')}
                </Text>
                <View wrap={false}>
                  {getAnnexes(e).map(item => item)}
                </View>
              </View>
            ))}
          </View>
        )
      }
      {/* Onglet "Annuaire / contacts utiles" */}
      {
        list_contacs_pro.length > 0 && (
          <View style={[styles.flexed, styles.mt20]} wrap={false}>
            <Text style={styles.subTitle} wrap={false}>Contacts utiles</Text>
            {list_contacs_pro.map(e => (
              <View wrap={false}>
                <Text style={styles.mt20} wrap={false}>
                  {e.full_name}
                </Text>
                <Text style={styles.assetLastUpdated} wrap={false}>
                  Dernière mise à jour : {moment(e.updated_at).format('L')}
                </Text>
                <View wrap={false}>
                  {getContactInfo(e).map(item => item)}
                </View>
              </View>
            ))}
          </View>
        )
      }
      {
        instructions && (
          <View style={styles.mt20} wrap={false}>
            <Text style={styles.subTitle} wrap={false}>Directives :</Text>
            <Text style={styles.infoText} wrap={false}>"{instructions}"</Text>
          </View>
        )
      }
    </View>
  );
};

// const getSeedInfo = (data) => {
//   let val = 'Stockée chez Legitbee';
//   const { secureKeyChoice } = data;
//   if (secureKeyChoice === 'legitbee_other') {
//     val = 'Répartie entre Legitbee et contacts ci-dessous :';
//   } else if (secureKeyChoice === 'other') {
//     val = 'Répartie entre contacts ci-dessous :';
//   }
//   return val;
// };

const displayInfo = (data, list_assets, contacts_pro) => {
  return (
    <View key={data._id} style={styles.mt20} wrap={false}>
      <Text wrap={false}>
        {data.title}
      </Text>
      <Text style={styles.assetLastUpdated}>
        Dernière mise à jour : {moment(data.updated_at).format('L')}
      </Text>
      {data.login_email && infoElement(data.login_email, 'Identifiant de connexion :')}
      {data.login_other && infoElement(data.login_other, 'Autre identifiant :')}
      {data.url !== undefined && data.url !== null && data.url.length > 0 && infoElement(data.url, 'Lien du compte :')}
      {data.type !== undefined && data.type !== null && data.type.length > 0 && infoElement(getLabelFromType(data.subcategory, data.type), 'Catégorie :')}
      {data.credential && infoElement(data.credential, 'Identifiant du compte :')}
      {data.public_key && infoElement(data.public_key, 'Clé publique :')}
      {/* {data.secureKeyChoice !== undefined && data.secureKeyChoice !== null && infoElement(getSeedInfo(data), 'Répartition de la graine :')} */}
      {data.contract_name && infoElement(data.contract_name, 'Nom du contrat :')}
      {data.contract && infoElement(data.contract, 'Numéro de contrat :')}
      {data.address && infoElement(data.address, 'Adresse :')}
      {data.iban && infoElement(data.iban, 'IBAN :')}
      {data.bic && infoElement(data.bic, 'Code BIC / SWIFT :')}
      {data.cloud_choice !== undefined && data.cloud_choice !== null && data.cloud_choice === 'delete' && infoElement('Suppression intégrale', 'Choix en cas de décès :')}
      {data.cloud_choice !== undefined && data.cloud_choice !== null && ['transmit_part', 'transmit_full'].includes(data.cloud_choice) && infoElement('Transmission', 'Choix en cas de décès :')}
      {data.permalinks !== undefined && data.permalinks !== null && data.permalinks.length > 0 && infoElement('à retrouver dans Legitbee', `${data.permalinks.length} permalien${data.permalinks.length > 1 ? 's' : ''} :`, 'hidden')}
      {data.contacts !== undefined && data.contacts.length > 0 && infoElement('à retrouver dans Legitbee', `${data.contacts.length} contact${data.contacts.length > 1 ? 's' : ''} associé${data.contacts.length > 1 ? 's' : ''} :`, 'hidden')}
      {data.notes && infoElement(data.notes, 'Informations complémentaires :', 'notes')}
      {data.documents && data.documents.length > 0 && infoElement('à retrouver dans Legitbee', `${data.documents.length} document${data.documents.length > 1 ? 's' : ''} associé${data.documents.length > 1 ? 's' : ''} :`, 'hidden')}
      {data.images && data.images.length > 0 && infoElement('à retrouver dans Legitbee', `${data.images.length} photo${data.images.length > 1 ? 's' : ''} associée${data.documents.length > 1 ? 's' : ''} :`, 'hidden')}
      {['estate', 'company'].includes(data.category) && listElements(data, list_assets, contacts_pro)}
    </View>
  );
};

// Create Document Component
const MyPdf = (props) => {
  const {
    userName, cleanList, last_updated, list_assets, contacts_pro,
  } = props;
  return (
    <Document>
      <Page size="A4" style={styles.coverPage}>
        <View style={styles.firstPage}>
          <View style={styles.borderBot}>
            <Text style={styles.title}>
              {userName}
            </Text>
            <Text style={styles.subText}>
              Dernière mise à jour le {moment(last_updated).format('L')}
            </Text>
          </View>
          <View style={styles.logo_wrapper}>
            <Image style={styles.image} src={`${process.env.PUBLIC_URL}/img/logo_bleu.png`} />
          </View>
        </View>
      </Page>
      {
        cleanList.map(item => (
          <Page key={item.title} size="A4" style={styles.page}>
            <Text style={styles.pageHeader} fixed>
              {item.title}
            </Text>
            {
              Object.keys(item.list).map((key) => {
                const list = item.list[key];
                return (
                  <View style={styles.categoryWrapper} key={key} wrap={false}>
                    <View style={styles.mt20}>
                      <Text style={styles.titleCat}>{getCategoryName(key)}</Text>
                    </View>
                    {
                      list.map(e => displayInfo(e, list_assets, contacts_pro))
                    }
                  </View>
                );
              })
            }
            <Text
              style={styles.pageNumbers}
              render={({ pageNumber, totalPages }) => (
                `${pageNumber} / ${totalPages}`
              )}
              fixed
            />
          </Page>
        ))
      }
    </Document>
  );
};

MyPdf.propTypes = {
  userName: PropTypes.string.isRequired,
  cleanList: PropTypes.arrayOf(PropTypes.shape({})),
  list_assets: PropTypes.arrayOf(PropTypes.shape({})),
  contacts_pro: PropTypes.arrayOf(PropTypes.shape({})),
  last_updated: PropTypes.number,
};

MyPdf.defaultProps = {
  cleanList: [],
  list_assets: [],
  contacts_pro: [],
  last_updated: 0,
};

export default MyPdf;
